export enum InvoiceStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface Invoice {
  id: string;
  documentNumber?: string;
  documentType?: string;
  dateIssue?: string;
  customerName?: string;
  customerNumberId?: string | null;
  amountWithTax?: number;
  status?: string; // "Procesado", "Error", "Anulada", etc.
  eInvoiceStatus?: number; // 0 = Procesado, 1 = Error, 5 = Anulada, etc.
  cufe?: string;
  resolution?: string;
  responseCode?: string;
  forceWaitOnEndpoints?: string;
  storeCode?: string;
  billingPoint?: string;
  createdDate?: string;
  lastModifiedDate?: string;

  // Detailed invoice fields (from getInvoiceById)
  payload?: any; // Parsed JSON payload with full invoice details
  response?: string;
  pacResponse?: string;
  billNumber?: string;
  qrCode?: string;
  einvoiceError?: string;
  cufeError?: string;
  responseDate?: string;
  createdBy?: string;
  lastModifiedBy?: string;
  authProtocol?: string;
  cafe?: string;
  xml?: string;

  // Legacy fields (for backward compatibility with mock data)
  invoiceNumber?: string;
  customerRuc?: string;
  date?: string;
  dueDate?: string;
  totalAmount?: number;
  createdAt?: string;
}

export interface InvoiceListResponse {
  invoices: Invoice[];
  // `null` cuando `searchApplied` es true (búsqueda con filtro de texto/
  // nombre/estado): el backend escanea Aludra de forma incremental y no
  // conoce el total real de coincidencias sin agotar el dataset completo —
  // ver invoiceSearchCursor.ts. Usar `hasMore`/`nextCursor` para paginar en
  // ese caso en vez de un total exacto.
  total: number | null;
  page: number;
  pageSize: number;
  /** true si esta respuesta viene del camino de filtro client-side (search/customerName/multi-estado). */
  searchApplied?: boolean;
  /** Solo con `searchApplied`: true si puede haber más coincidencias más allá de esta página. */
  hasMore?: boolean;
  /** Solo con `searchApplied`: token opaco para pedir la próxima página con `cursor`. `null` si no hay más. */
  nextCursor?: string | null;
}

// Email notification types
export interface EmailReceiver {
  Email: string;
  Name: string;
}

export interface EmailAttachments {
  dResponseAuthXML: boolean;
  dResponseXML: boolean;
  dCFe: boolean;
  dCAFE: boolean;
}

export interface ResendEmailRequest {
  electronicInvoiceId: string;
  companyId: string;
  attachments: EmailAttachments;
  receivers: EmailReceiver[];
}
